import { Button } from "@/components/ui/button";
import { Flag, Heart, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-card border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-independence rounded-lg flex items-center justify-center">
                <Flag className="w-6 h-6 text-primary-foreground" />
              </div>
              <span className="text-2xl font-bold text-foreground">
                Bazaria<span className="text-accent"> Digital</span>
              </span>
            </div>

            <p className="text-muted-foreground mb-6 max-w-md">
              Merayakan HUT Kemerdekaan RI ke-80 dengan marketplace digital yang
              menampilkan produk-produk lokal terbaik Indonesia. Mari bersama
              membangun ekonomi kerakyatan!
            </p>

            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <span>Dibuat dengan</span>
              <Heart className="w-4 h-4 fill-primary text-primary" />
              <span>untuk BAP Digital UMKM</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Quick Link</h3>
            <ul className="space-y-3">
              {[
                { name: "Beranda", href: "/" },
                { name: "Katalog", href: "/#catalog" },
                { name: "Tentang", href: "/about" }, // Ganti href ke AboutBazar.tsx route
                // { name: "Titip Jual", href: "/sell-product" },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">
              Kontak Team Support
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-muted-foreground">
                <MapPin className="w-4 h-4 text-primary" />
                <span className="text-sm">Surabaya, Indonesia</span>
              </li>
              <li className="flex items-center space-x-3 text-muted-foreground">
                <Phone className="w-4 h-4 text-primary" />
                <span className="text-sm">+62 812-3456-7890</span>
              </li>
              <li className="flex items-center space-x-3 text-muted-foreground">
                <Mail className="w-4 h-4 text-primary" />
                <span className="text-sm">info@bazariadigital.id</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-muted-foreground mb-4 md:mb-0">
            © {currentYear} Bazaria Digital. Semua hak cipta dilindungi.
          </div>

          <div className="flex items-center space-x-4">
            <Button variant="ghost" size="sm" className="text-xs">
              Kebijakan Privasi
            </Button>
            <Button variant="ghost" size="sm" className="text-xs">
              Syarat & Ketentuan
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
